import { decimalCursorSchema } from '@der-maschinfuehrer/contracts';
import { FullResyncRequiredError } from '../errors.js';
export function nextSnapshotMutationGeneration(runtime) {
    if (runtime.mutation_generation === undefined) {
        throw new FullResyncRequiredError('local mutation generation is missing');
    }
    return (BigInt(decimalCursorSchema.parse(runtime.mutation_generation)) + 1n).toString();
}
//# sourceMappingURL=snapshot-generation.js.map